import { database } from '../../firebase';
import {map} from 'lodash';
import { createAction, handleActions } from 'redux-actions';

export enum STRIPE_CONNECT_ACTION_TYPES {
  CONNECT_ACCOUNT_FOUND = '@DONACO/CONNECT_ACCOUNT_FOUND',
  CONNECT_ACCOUNT_RESET = '@DONACO/CONNECT_ACCOUNT_RESET',
  ADD_ALL_CONNECT_ACCOUNTS = '@DONACO/ADD_ALL_CONNECT_ACCOUNTS',
}

const defaultState = {
  accounts: null,
  account: undefined,
};

const connectAccountResetAction = createAction(STRIPE_CONNECT_ACTION_TYPES.CONNECT_ACCOUNT_RESET);
const connectAccountFoundAction = createAction(STRIPE_CONNECT_ACTION_TYPES.CONNECT_ACCOUNT_FOUND, (payload) => payload);
const fetchAllConnectAccountsAction = createAction(STRIPE_CONNECT_ACTION_TYPES.ADD_ALL_CONNECT_ACCOUNTS, (payload) => payload);

export const resetStripeConnectAccount = () => (dispatch) => dispatch(connectAccountResetAction());

export const fetchStripeConnectAccount = (uid) => {
  return (dispatch) => {
    database.ref(`/stripeConnectedAccounts/${uid}`)
      .once('value')
      .then(accRef => {
        const stripeAccount = accRef.val();
        return dispatch(connectAccountFoundAction(stripeAccount));
      });
  };
};

export const fetchAllStripeConnectAccounts = () => {
  return (dispatch) => {
    database.ref('/stripeConnectedAccounts').on('value', (snapshot) => {
      const connectedAccounts = snapshot.val();
      const users = database.ref('/users');
      map(connectedAccounts, (stripeAccount, userKey: string) => {
        users.child(userKey).once('value', (userSnapshot) => {
          const account = {
            [userKey]: {
              ...stripeAccount,
              ...userSnapshot.val()
            }
          };
          return dispatch(fetchAllConnectAccountsAction(account));
        });
      });
    });
  };
};

/**
 * Copies the stripe account data from /stripeConnectedTokens to /stripeConnectedAccounts and sets the account value in the /charity object.
 *
 * This is called as the final step during Stripe onboarding. The /profile/oauth-callback server function saves the stripe data, but
 * it doesn't know who the user is, so it passes the tokenKey back to the dashboard which then calls this function.
 *
 * @param tokenKey key in /stripeConnectedTokens corresponding to newly onboarded stripe account
 * @param authId userID performing the onboarding
 */
export const addTokenToAccount = (tokenKey: string, authId: string) => {
  return (dispatch) => {
    let stripeAccount;
    // retrieve the stripe account data set via /profile/oauth-callback function
    database.ref(`/stripeConnectedTokens/${tokenKey}`).once('value')
      .then(snapshot => stripeAccount = snapshot.val())
      .then(() => Promise.all([
        // replicate the stripe account data in the /stripeConnectedAccounts key
        database.ref(`/stripeConnectedAccounts/${authId}`).set({ ...stripeAccount }),
        // add the stripe account ID to the charity
        database.ref(`/users/${authId}/charityKey`)
          .once('value')
          .then(x => {
            const charityKey = x.val();
            return database.ref(`/charities/${charityKey}/stripeAccount`).set(stripeAccount.stripeUserId);
          })
        ])
      ).then(() => {
        // notify that we now have a stripe account
        dispatch(connectAccountFoundAction(stripeAccount));
      });
  };
};

export const stripeConnectReducer = handleActions({
  [STRIPE_CONNECT_ACTION_TYPES.CONNECT_ACCOUNT_FOUND]: (state, action) => {
    const account = action.payload;
    return {
      ...state,
      account,
    };
  },
  [ STRIPE_CONNECT_ACTION_TYPES.CONNECT_ACCOUNT_RESET ]: (state) => {
    return {
      ...state,
      account: undefined,
    };
  },
  [ STRIPE_CONNECT_ACTION_TYPES.ADD_ALL_CONNECT_ACCOUNTS ]: (state, action) => {
    const account = action.payload;
    const existingAccounts = state.accounts;
    return {
      ...state,
      accounts: {
        ...existingAccounts,
        ...account
      }
    };
  }
}, defaultState);
